import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import RichContentMap from "./RichContentMap.js";
import RichContentImages from "./RichContentImages.js";
const RichChatBubble = (props) => {
  const msg = props.data;
  switch (msg.type) {
    case "images":
      return /* @__PURE__ */ jsx("div", { className: "chat-bubble tall", children: /* @__PURE__ */ jsx(RichContentImages, { images: msg.content.images }) });
    case "delivery-map":
      return /* @__PURE__ */ jsx("div", { className: "chat-bubble tall", children: /* @__PURE__ */ jsx(
        RichContentMap,
        {
          destination: props.data.content.deliveryMap.destination
        }
      ) });
    case "ofd-map":
      return /* @__PURE__ */ jsx("div", { className: "chat-bubble tall", children: /* @__PURE__ */ jsx(
        RichContentMap,
        {
          origin: props.data.content.map.origin,
          destination: props.data.content.map.destination
        }
      ) });
  }
};
RichChatBubble.propTypes = {
  data: PropTypes.object
};
export {
  RichChatBubble as default
};
//# sourceMappingURL=RichChatBubble.js.map
